// consolidate the software themed routes to src/packages/platform/project-theme/page-container/src/controllers/project-theme/constants.tsx
// when we migrate the software project theming to business

export const SOFTWARE_CONTOURED_THEME_ROUTES = new Set([
	'issue',
	'software-backlog',
	'rapidboard-backlog',
	'software-timeline',
	'software-timeline-classic',
	'software-issue-navigator',
	'issue-navigator-classic',
]);

// delete this on jira_theming_milestone_2 cleanup
export const SOFTWARE_FULL_THEME_ROUTES = new Set([
	'software-boards',
	'rapidboard-board',
	'software-calendar',
	'software-calendar-classic',
	'software-list',
	'software-list-classic',
	'software-summary',
	'software-summary-classic',
]);

export const SOFTWARE_CONTOURED_THEME_ROUTES_M2 = new Set([
	'issue',
	'software-timeline',
	'software-timeline-classic',
	'software-issue-navigator',
	'issue-navigator-classic',
]);

export const SOFTWARE_FULL_THEME_ROUTES_M2 = new Set([
	'software-boards',
	'rapidboard-board',
	'software-calendar',
	'software-calendar-classic',
	'software-list',
	'software-list-classic',
	'software-summary',
	'software-summary-classic',
	'software-backlog',
	'rapidboard-backlog',
	'project-pages',
	'software-form-classic',
	'software-form',
	'software-form-builder-classic',
	'software-form-builder',
]);

// delete this on jira_theming_milestone_2 cleanup
export const SOFTWARE_THEME_ROUTES = new Set([
	...SOFTWARE_CONTOURED_THEME_ROUTES,
	...SOFTWARE_FULL_THEME_ROUTES,
]);

export const SOFTWARE_THEME_ROUTES_M2 = new Set([
	...SOFTWARE_CONTOURED_THEME_ROUTES_M2,
	...SOFTWARE_FULL_THEME_ROUTES_M2,
]);
